import { defineComponent as _defineComponent } from 'vue'
import { withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { h, useSlots, reactive } from "vue";
      import { assignSlotNodes, Slots } from "@lit-labs/vue-utils/wrapper-utils.js";
      import '@oicl/openbridge-webcomponents/dist/components/alert-list-details/alert-list-details.js';
      import {ObcAckClickEvent, ObcRowClickEvent, AlertListMode} from '@oicl/openbridge-webcomponents/dist/components/alert-list-details/alert-list-details.js';
import {Alert} from '@oicl/openbridge-webcomponents/dist/types.js';

      export interface Props {
     selectedMode?: AlertListMode;
     alerts?: Alert[];
     showTime?: boolean;
     timeFormatter?: (time: Date) => string;
     small?: boolean
   }

      
  
      export type {ObcAckClickEvent, ObcRowClickEvent, AlertListMode} from '@oicl/openbridge-webcomponents/dist/components/alert-list-details/alert-list-details.js';
export type {Alert} from '@oicl/openbridge-webcomponents/dist/types.js';
    
export default /*@__PURE__*/_defineComponent({
  __name: 'ObcAlertListDetails',
  props: {
    selectedMode: {},
    alerts: {},
    showTime: { type: Boolean },
    timeFormatter: { type: Function },
    small: { type: Boolean }
  },
  emits: ["ack-click", "row-click"],
  setup(__props: any, { emit: __emit }) {

      const vueProps = __props;

  const defaults = reactive({} as Props);
  const vDefaults = {
    created(el: any) {
      for (const p in vueProps) {
        defaults[p as keyof Props] = el[p];
      }
    }
  };

  let hasRendered = false;

      const emit = __emit;

      const slots = useSlots() as Slots;

      const render = () => {
        const eventProps = {
    onAckClick: (event: ObcAckClickEvent) => emit('ack-click', event as ObcAckClickEvent),
onRowClick: (event: ObcRowClickEvent) => emit('row-click', event as ObcRowClickEvent)
  };
        const props = eventProps as (typeof eventProps & Props);

        
      for (const p in vueProps) {
        const v = vueProps[p as keyof Props];
        if ((v !== undefined) || hasRendered) {
          (props[p as keyof Props] as unknown) = v ?? defaults[p as keyof Props];
        }
      }

      hasRendered = true;
    

        return h(
          'obc-alert-list-details',
          props,
          assignSlotNodes(slots)
        );
      };
    
return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createBlock(render, null, null, 512)), [
    [vDefaults]
  ])
}
}

})